import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { LoadingService } from '../../../core/services/loading.service';

@Component({ selector: 'app-loader', standalone: true, imports: [NgIf], templateUrl: './loader.component.html', styleUrls: ['./loader.component.css'], changeDetection: ChangeDetectionStrategy.OnPush })
export class LoaderComponent { constructor(readonly loading: LoadingService) {} }
